import { Lightbulb } from 'lucide-react';

export function AutoOtherInfo() {
  return (
    <div
      style={{
        marginTop: '1.5rem',
        padding: '1rem',
        background: 'linear-gradient(135deg, rgba(223,195,47,0.1) 0%, rgba(223,195,47,0.3) 100%)',
        border: '1px solid #dfc32f',
        borderRadius: '12px',
      }}
    >
      <div
        style={{
          fontSize: '0.85rem',
          color: '#b45309',
          lineHeight: '1.5',
          display: 'flex',
          gap: '0.5rem',
          alignItems: 'flex-start',
        }}
      >
        <Lightbulb size={20} color="#b45309" style={{ marginTop: '0.1rem', flexShrink: 0 }} />
        <div>
          <strong>Option "Autre" automatique :</strong> Les clients auront toujours la possibilité de choisir
          "Autre disposition" et de décrire leur besoin spécifique dans un champ texte.
        </div>
      </div>
    </div>
  );
}
